<script>
    import DashboardDropdown from "../components/DashboardDropdown.vue";

    const content = [
        {
            image: require("@/assets/img/link.svg"),
            text: "Links",
            url: "#dashboard",
            to: "/user/links",
            class: "/user/links",
        },
        // {
        //   image: require("@/assets/img/files.svg"),
        //   text: "Files",
        //   url: "#dashboard",
        //   to: "/user/files",
        //   class: "/user/files",
        // },
        {
            image: require("@/assets/img/google.svg"),
            text: "Google Drive",
            url: "#dashboard",
            to: "/user/google",
            class: "/user/google",
        },
        {
            image: require("@/assets/img/text.svg"),
            text: "Text",
            url: "#dashboard",
            to: "/user/text",
            class: "/user/text",
        },
        // {
        //   image: require("@/assets/img/q_a.svg"),
        //   text: "Q&A",
        //   url: "#dashboard",
        //   to: "/user/q_a",
        //   class: "/user/q_a",
        // },
        ];

        const customizations = [
        // {
        //   image: require("@/assets/img/clock.svg"),
        //   text: "Quick prompts",
        //   url: "#dashboard",
        //   to: "/user/prompt",
        //   class: "/user/prompt",
        // },
        // {
        //   image: require("@/assets/img/star.svg"),
        //   text: "Follow up prompts",
        //   url: "#dashboard",
        //   to: "/user/follow_prompt",
        //   class: "/user/follow_prompt",
        // },
        {
            image: require("@/assets/img/art.svg"),
            text: "Appearance",
            url: "#dashboard",
            to: "/user/appearance",
            class: "/user/appearance",
        },
    ];
    
    const advanced = [
        {
            image: require("@/assets/img/chat_history.svg"),
            text: "Chat history",
            url: "#dashboard",
            to: "/user/chat_history",
            class: "/user/chat_history",
        },
        // {
        //   image: require("@/assets/img/integration.svg"),
        //   text: "Integration",
        //   url: "#dashboard",
        //   to: "/user/integration",
        //   class: "/user/integration",
        // },
        // {
        //   image: require("@/assets/img/settings.svg"),
        //   text: "Settings",
        //   url: "#dashboard",
        //   to: "/user/settings/general",
        //   class: "/user/settings/general",
        // },
        // {
        //   image: require("@/assets/img/integration.svg"),
        //   text: "Integration",
        //   url: "#dashboard",
        //   to: "/user/integration",
        //   class: "/user/integration",
        // },
        {
            image: require("@/assets/img/settings.svg"),
            text: "Settings",
            url: "#dashboard",
            to: "/user/settings/general",
            class: "/user/settings",
        },
    ];

export default {
    components: {
        DashboardDropdown
    },
    props: {
        sidebarShown: Boolean,
        chosenWidget: Object,
        userWidgets: Array,
        toggleSidebar: Function,
        closeSidebar: Function,
        getChosenWidget: Function,
        deleteWidget: Function,
        editWidget: Function
    },
    data() {
        return {

        }
    },
    computed: {
        icons_content() {
            return content;
        },
        icons_customizations() {
            return customizations;
        },
        icons_advanced() {
            return advanced
        }
    },
    methods: {

    },
 }
</script>

<template>
    <aside
      v-click-outside="closeSidebar"
      class="dashboard__sidebar"
      :class="{ sideOpen: sidebarShown }"
    >
      <!-- <mobile-menu slot="content"></mobile-menu> -->
      <div class="dashboard__sidebar-top-wrapper">
        <div class="logo__wrapper">
          <img class="logo" src="../assets/img/logo_reply.svg" alt="logo" />
        </div>
        <DashboardDropdown
          :disabledList="userWidgets.length === 0"
          :chooseWidget="getChosenWidget"
          :items="userWidgets"
          :deleteWidget="deleteWidget"
          :editWidget="editWidget"
        />
        <nav v-if="userWidgets.length !== 0" class="nav__main" :class="{nav__disabled: !chosenWidget}">
          <router-link class="side-nav-link bold" to="/user/dashboard">
            <div @click="sidebarShown = false" class="link-click-wrapper">
              <svg
                :class="{ active: $route.path === '/user/dashboard' }"
                class="dasboard_svg"
              >
                <use xlink:href="../assets/img/dash_icon.svg#dashboard"></use>
              </svg>

              <span
                class="website_link"
                :class="{ active: $route.path === '/user/dashboard' }"
                >Dashboard</span
              >
            </div>
          </router-link>
          <div class="no_active_link">
            <span class="website_link noactive">Content</span>
          </div>
          <router-link
            class="side-nav-link"
            :to="icon.to"
            v-for="(icon, index) in icons_content"
            :key="index"
          >
            <div @click="sidebarShown = false" class="link-click-wrapper">
              <svg
                :class="{ active: $route.path === icon.class }"
                class="dasboard_svg"
              >
                <use :xlink:href="`${icon.image}${icon.url}`"></use>
              </svg>

              <span
                class="website_link"
                :class="{ active: $route.path === icon.class }"
                >{{ icon.text }}</span
              >
            </div>
          </router-link>

          <div class="no_active_link">
            <span class="website_link noactive">Customizations</span>
          </div>
          <router-link
            class="side-nav-link"
            :to="icon.to"
            v-for="icon in icons_customizations"
            :key="icon.to"
          >
            <div @click="sidebarShown = false" class="link-click-wrapper">
              <svg
                :class="{ active: $route.path === icon.class }"
                class="dasboard_svg"
              >
                <use :xlink:href="`${icon.image}${icon.url}`"></use>
              </svg>

              <span
                class="website_link"
                :class="{ active: $route.path === icon.class }"
                >{{ icon.text }}</span
              >
            </div>
          </router-link>

          <div class="no_active_link">
            <span class="website_link noactive">Advanced</span>
          </div>

          <router-link
            class="side-nav-link"
            :class="{ active: $route.path.includes(icon.class) }"
            :to="icon.to"
            v-for="icon in icons_advanced"
            :key="icon.to"
          >
            <div @click="sidebarShown = false" class="link-click-wrapper">
              <svg
                :class="{ active: $route.path.includes(icon.class) }"
                class="dasboard_svg"
              >
                <use :xlink:href="`${icon.image}${icon.url}`"></use>
              </svg>

              <span
                class="website_link"
                :class="{ active: $route.path.includes(icon.class) }"
                >{{ icon.text }}</span
              >
            </div>
          </router-link>
        </nav>
      </div>

      <div class="nav__bottom">
        <div class="nav__bottom-list">
          <span class="nav__bottom-email">support@replymonster.ai</span>
        </div>
        <!-- <ul >
          <li class="nav__bottom-list-item">
            <router-link to="#" class="list-item__link">
              Help and Support
            </router-link>
          </li>
          <li class="nav__bottom-list-item">
            <router-link to="#" class="list-item__link"> Feedback </router-link>
          </li>
          <li class="nav__bottom-list-item">
            <router-link to="#" class="list-item__link">
              Help center
            </router-link>
          </li>
        </ul> -->
      </div>

      <!-- <template slot="bottom-links"> </template> -->
    </aside>
</template>

<style lang="scss" scoped>
.dashboard__sidebar {
    background-color: #f8f9fa;
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid #e7e7e7;
    z-index: 2;
    transform: translate(-100%, 0);
    transition: all 150ms linear;

    @media (min-width: 1480px) {
    transform: translate(0, 0);
    position: sticky;
    /* height: 100%; */
    /* width: 280px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between; */
    }

    &.sideOpen {
        transform: translate(0, 0);
    }
}

.logo__wrapper {
    padding: 40px;
}

.logo {
    width: 158px;
    height: auto;
}

.link-click-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.nav__disabled {
    pointer-events: none;
    opacity: 0.8;
}

.side-nav-link {
    display: flex;
    /* align-items: center;
    gap: 10px; */
    font-family: "Inter", sans-serif;
    color: #637381;
    width: 100%;
    padding: 9px 0 9px 14px;
    text-decoration: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    transition: all 150ms linear;

    &.bold {
        font-weight: 700;
    }

    &:hover:not(.active),
    :focus-visible:not(.active) {
        color: #3056d3;
    }

    &.active {
        background-color: #edf2ff;
        color: #3056d3;
        border-right: 3px solid;
    }
}

.dasboard_svg.active {
    fill: #3056d3;
}

.no_active_link {
    margin-top: 8px;
    padding: 9px 0 9px 0;
}
.noactive {
    color: #4f4f4f;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    padding-left: 40px;
    margin-top: 8px;
}

.nav__bottom-list {
    width: 200px;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 0 40px 0;
    margin: 0;
    margin-left: 40px;
    border-top: 1px solid #e7e7e7;
}

.nav__bottom-list {
}

.nav__bottom-email {
  color: #637381;
  font-size: 16px;
  line-height: 24px;
}
.list-item__link {
    text-decoration: none;
    color: #637381;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    transition: all 150ms linear;

    &:hover,
    :focus-visible {
        color: #3056d3;
    }
}
</style>